import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowRight, Mail } from 'lucide-react'
import { CONTACT_INFO, contactPath } from '@/lib/constants'
import Reveal from './Reveal'

/** Closing call-to-action used at the bottom of most pages. */
export default function CtaBand({
  title,
  subtitle,
  product,
}: {
  title?: string
  subtitle?: string
  product?: string
}) {
  const { t } = useTranslation('common')

  return (
    <section className="container py-16 md:py-24">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl bg-brand-navy px-6 py-10 text-white shadow-lift sm:px-12 sm:py-14 md:py-16">
          <div aria-hidden className="absolute -top-24 end-0 h-72 w-72 rounded-full bg-brand-cyan/30 blur-3xl" />
          <div aria-hidden className="absolute -bottom-24 start-10 h-72 w-72 rounded-full bg-brand-blue/40 blur-3xl" />
          <div className="relative flex flex-col items-stretch gap-6 sm:items-start sm:gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div className="max-w-2xl space-y-2.5 sm:space-y-3">
              <h2 className="text-2xl font-bold sm:text-3xl md:text-4xl">{title ?? t('cta.title')}</h2>
              <p className="text-base text-white/75 sm:text-lg">{subtitle ?? t('cta.subtitle')}</p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
              <Link
                to={contactPath({ product, topic: product ? (product === 'masar' ? 'waitlist' : 'demo') : undefined })}
                className="inline-flex h-12 items-center justify-center gap-2 rounded-xl bg-white px-6 font-semibold text-brand-navy transition-colors hover:bg-white/90"
              >
                {t('cta.primary')}
                <ArrowRight className="h-4 w-4 flip-rtl" />
              </Link>
              <a
                href={`mailto:${CONTACT_INFO.email}`}
                className="inline-flex h-12 items-center justify-center gap-2 rounded-xl border border-white/25 px-6 font-medium text-white transition-colors hover:bg-white/10"
              >
                <Mail className="h-4 w-4 shrink-0" />
                <span className="truncate">{CONTACT_INFO.email}</span>
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  )
}
